import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { Component, Output, EventEmitter, Input, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateFormatPipe, LanguagePipe } from '@aston/foundation/pipes';
import { MultiSearchInputComponent } from '@aston/multi-search-input';
import { PageHeaderComponent } from '@aston/foundation/components';
import { AppLanguage, ActionType } from '@aston/foundation/enums';
import { IAction, ISearchItem } from '@aston/foundation/models';
import { UnsubscriberClass  } from '@aston/foundation/classes';
import { ClipboardService } from '@aston/foundation/services';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { IUserAvatar } from '@aston/user-badge';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';

import { NotificationsStoreSelectors } from '../../../root-store/notifications-store';
import { AppStoreActions, AppStoreSelectors } from '../../../root-store/app-store';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { environment } from '../../../../environments/environment';
import { BrandingPipe } from '../../pipes';

import { TopBarSearchStore } from './top-bar.search.store';

@Component({
	selector: '[layout-top-bar]',
	templateUrl: './top-bar.component.html',
	imports: [
		AsyncPipe,
		BrandingPipe,
		UserAvatarComponent,
		DateFormatPipe,
		LanguagePipe,
		NgSelectModule,
		PageHeaderComponent,
		NgbTooltipModule,
		TranslateModule,
		UpperCasePipe,
		FormsModule,
		NgbDropdownModule,
		MultiSearchInputComponent,
	],
	providers: [TopBarSearchStore]
})
export class TopBarComponent extends UnsubscriberClass {
	private searchStore = inject(TopBarSearchStore);
	protected i18n = inject(TranslateService);
	protected cb = inject(ClipboardService);
	protected store = inject(Store);

	@Input() currentLanguage: AppLanguage;
	@Input() user: IUserAvatar;
	@Input() tenantName: string;
	@Input() tenantLogo: string;
	@Input() tenantConsoleId: number;
	@Input() tenantLastUpdateDate: Date;

	@Output() selectLanguage = new EventEmitter<AppLanguage>();
	@Output() logout = new EventEmitter<void>();
	@Output() action = new EventEmitter<IAction>();

	fr = AppLanguage.FR;
	en = AppLanguage.EN;
	hasTranslations = environment.translations.enabled;
	path = window.location.href;

	searchGroups = this.searchStore.results;
	searchResultsWithMore = this.searchStore.sortedResultsWithMore;

	operator$ = this.store.select(AppStoreSelectors.selectCurrentUser);
	unreadNotificationsCount$ = this.store.select(NotificationsStoreSelectors.selectUnreadCount);

	config$ = this.store.select(AppStoreSelectors.selectConfig);

	setLanguage(language: AppLanguage) {
		this.selectLanguage.emit(language);
	}

	userLogout() {
		this.logout.emit();
	}

	leavePlatform() {
		this.store.dispatch(AppStoreActions.NavigateToConsole({path: '/dashboard/subsidiaries'}))
	}

	editMyInformations() {
		this.store.dispatch(AppStoreActions.NavigateToGate({path: '/Account/edit?ReturnUrl=' + encodeURIComponent(this.path)}))
	}

	toggleNotificationsPanel() {
		this.action.emit({type: ActionType.TOGGLE, value: 'notifications'});
	}

	toggleThemesPanel() {
		this.action.emit({type: ActionType.TOGGLE, value: 'themes'});
	}

	search(term: string) {
		this.searchStore.search(term);
	}

	pickSearchResult(item: ISearchItem) {
		this.searchStore.select(item);
	}

	openHelp() {
		this.store.dispatch(AppStoreActions.NavigateToHelpPage())
	}

	cpcSupportPhone() {
		const text = this.i18n.instant('TopBar.Tooltip.Contact').split(':').pop().trim()
		this.cb.writeText(text)
	}

	updatePlatform() {
		//
	}
}
